// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-combo"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 12H19V21H15V12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7 15H11V21H7V15Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.8318 8.29949L16.6709 5.13867L9.88902 11.8783L6.70703 8.6963M15 12H19V21H15V12ZM7 15H11V21H7V15Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartComboIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-combo',
    ref,
    icon: element,
  },
));

ChartComboIcon.displayName = 'ChartComboIcon';

export default ChartComboIcon;
